import { toggleClass } from '~/js/utils/class-management';

function makeAccordions() {
  const accordionsTitles = document.querySelectorAll('.accordion-heading');
  if (!accordionsTitles.length) return;
  accordionsTitles.forEach((accordion) => {
    accordion.addEventListener('click', () => {
      const panel = accordion.nextElementSibling;
      if (panel) {
        toggleClass(accordion, 'active');
        toggleClass(panel, 'opened');
      }
    });
  });
}

export default makeAccordions;
